import { Popover } from "bootstrap";
import { BaseFCProps, FC, PopoverMap } from "../components";

export const VenuePopover: FC = ({ selector = '[data-venue-popover]' }: BaseFCProps = {}) => {
  Array.from(document.querySelectorAll(selector)).forEach((node) => {
    const popoverNode = node as HTMLElement;
    const popover = new Popover(popoverNode, { html: true }) as any;
    popoverNode.addEventListener('shown.bs.popover', () => {
      try {
        const content = popoverNode.dataset.venuePopover || '{}';
        const options = JSON.parse(content.replace(/'/g, ''));
        const map = PopoverMap.create(options, popover.tip);
        map.render();
      } catch (e) {
        throw new Error('ERROR_PARSING_MAP_OPTIONS')
      }
    });
  });
}